import { Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { StatusContainer } from "./styles";

interface Props {
  auditAccepted: boolean | null;
}

const ReceiptStatus = ({ auditAccepted }: Props) => {
  const tRP = "components.expense_reports";
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <StatusContainer>
      {auditAccepted === null && (
        <>
          {/* <FontAwesomeIcon
            icon={faClock}
            color={theme.palette.text.disabled}
          /> */}
          <Typography sx={{ color: theme.palette.text.disabled }}>{`${t(`${tRP}.pending`)}`}</Typography>
        </>
      )}

      {auditAccepted === true && (
        <>
          {/* <FontAwesomeIcon
            icon={faCircleCheck}
            color={theme.palette.success.main}
          /> */}
          <Typography sx={{ color: theme.palette.success.main }}>{`${t(`${tRP}.accepted`)}`}</Typography>
        </>
      )}

      {auditAccepted === false && (
        <>
          <Typography sx={{ color: theme.palette.error.main }}>{`${t(`${tRP}.rejected`)}`}</Typography>
        </>
      )}
    </StatusContainer>
  );
};

export default ReceiptStatus;
